import React, { useState } from 'react'
import { FaAngleDown, FaAngleRight, FaFacebookF, FaLinkedinIn, FaXTwitter, FaYoutube } from 'react-icons/fa6'
import { Link, useNavigate } from 'react-router-dom'
import logo from '../img/helplogo.jpg'

function BottomBar() {

    const [link1, setlink1] = useState(false)
    const [link2, setlink2] = useState(false)

    const navigate = useNavigate()

  return (
    <div className='about_sub' >
        <div className='subscrie_container' >
            <div className='subscrie_container_img' ></div>
            <div className='subscrie_container_writes'>
                <div className='about_sub_header'>
                    <div style={{backgroundColor:'white'}} className='about_sub_header_line'></div>
                    <h2>NEWS LETTER</h2>

                    <p>Find out how we're changing the lives of people – and how you can help. You can opt-out at any time. For more information on how we use your data, see our privacy policy. Over 18s only</p>

                    <div className='subscrie_container_input_field' >
                        <input placeholder='First Name' />
                        <input placeholder='Email' />
                        <input placeholder='Mobile' />
                        <div className='subscrie_container_input_field_btn'>
                            <h3>SIGN UP</h3>
                            <FaAngleRight/>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className='bottom_bar'>
            <div className='bottom_links'>
                <Link to={'/'} className='desk_header_logo' >
                    <img className='desk_header_img' src={logo} alt='' />
                    <h3>THE LORD Nations FOUNDATION</h3>
                </Link>
            </div>

            <div className='bottom_links'>
                    <h3>JOIN US</h3>
                <div onClick={()=>link1 ? setlink1(false) : setlink1(true)} className='MOBILE_btm_link_hd' >
                    <h3>JOIN US</h3>
                    <FaAngleDown  color='#da291c' />
                </div>

                {
                    link1 ?
                    <div className='MOBILE_btm_links'>
                        <p onClick={()=>navigate('/donate-now')} >Donate Now</p>
                        <p onClick={()=>navigate('/donate-monthly')} >Donate Monthly</p>
                        <p onClick={()=>navigate('/learn-share')} >Learn & Share</p>
                        <p onClick={()=>navigate('/partner-with-us')} >Partner With Us</p>
                        <p onClick={()=>navigate('/our-impact')} >our-impact</p>
                    </div>
                    : null
                }

                <p onClick={()=>navigate('/donate-now')} >Donate Now</p>
                <p onClick={()=>navigate('/donate-monthly')} >Donate Monthly</p>
                <p onClick={()=>navigate('/learn-share')} >Learn & Share</p>
                <p onClick={()=>navigate('/partner-with-us')} >Partner With Us</p>
                <p onClick={()=>navigate('/our-impact')} >our-impact</p>
            </div>

            <div className='bottom_links'>
                <h3>QUICK LINKS</h3>

                <div onClick={()=>link2 ? setlink2(false) : setlink2(true)} className='MOBILE_btm_link_hd' >
                    <h3>QUICK LINKS</h3>
                    <FaAngleDown color='#da291c' />
                </div>


                {
                    link2 ?
                    <div className='MOBILE_btm_links'>
                        <p onClick={()=>navigate('/about-us')} >About Us</p>
                        <p onClick={()=>navigate('/contact-us')} >Contact Us</p>
                        <p onClick={()=>navigate('/news')} >News</p>
                        <p onClick={()=>navigate('/stories')} >Stories</p>
                    </div>
                    : null
                }

                
                <p onClick={()=>navigate('/about-us')} >About Us</p>
                <p onClick={()=>navigate('/contact-us')} >Contact Us</p>
                <p onClick={()=>navigate('/news')} >News</p>
                <p onClick={()=>navigate('/stories')} >Stories</p>
            </div>

            <div className='bottom_links'>
                <h3>FOLLOW US</h3>
                <div className='bottom_links_share'>
                
                    <Link style={{textDecoration:'none'}} to={'https://x.com/thelordnations'} target='/blank' >
                        <FaXTwitter className='bottom_links_share_icons'/>
                    </Link>

                    <FaFacebookF className='bottom_links_share_icons' />
                    <FaLinkedinIn className='bottom_links_share_icons' />

                    <Link style={{textDecoration:'none'}} to={'https://www.youtube.com/channel/UC4a-5DWULTzb_aV23tTls4A'} target='/blank' >
                        <FaYoutube className='bottom_links_share_icons' />
                    </Link>
                    
                </div>
            </div>

        </div>

        
        <div className='bottom_bar_links'>
            <div className='bottom_bar_privacy_links'>
                <Link className='bottom_bar_privacy_link' >
                    <p>Legal</p>
                </Link>
                <Link className='bottom_bar_privacy_link'>
                    <p>Privacy Policy</p>
                </Link>
                <Link className='bottom_bar_privacy_link'>
                    <p>Cookie Policy</p>
                </Link>
                <Link className='bottom_bar_privacy_link'>
                    <p>Recruitment Privacy Policy</p>
                </Link>
            </div>

            <div className='bottom_bar_'>
                <p>© 2025 THE LORD Nations FOUNDATION</p>
            </div>
        </div>
    </div>
  )
}

export default BottomBar